import React from "react";
import { array, object, bool, string } from "prop-types";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";

import "./row2.m.css";

const Row2 = ({ stories, liveBlogStory, updatedFont, publisherLang, src }) => {
  const organism1Stories = stories.slice(0, 4);
  const organism2Stories = stories.slice(4, 10);
  const organism3Stories = stories.slice(10, 12);

  return (
    <div styleName="base">
      <div>
        {organism1Stories.length > 0 && (
          <Organism1
            stories={organism1Stories}
            updatedFont={updatedFont}
            publisherLang={publisherLang}
            src="fourteen-stories-3ad-1-widget"
            liveBlogStory={liveBlogStory}
          />
        )}
        {organism2Stories.length > 0 && <Organism2 stories={organism2Stories} updatedFont={updatedFont} src={src} />}
      </div>
      {organism3Stories.length > 0 && (
        <div styleName="two-stories-wrapper" className={`${publisherLang}-two-stories-wrapper`}>
          {organism3Stories.map((story, index) => (
            <CustomStoryCard4
              story={story.story}
              key={index}
              headlineType={37}
              showStoryMetaInfo={true}
              updatedFont={updatedFont}
            />
          ))}
        </div>
      )}
    </div>
  );
};

Row2.propTypes = {
  stories: array.isRequired,
  updatedFont: bool,
  src: string,
  publisherLang: string,
  liveBlogStory: object,
};

export default Row2;
